import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteLocation } from '../mutations/deleteLocation.mutation';
import type { DeleteLocationMutation, DeleteLocationMutationVariables } from '../types';

export const useDeleteLocationMutation = (
  options?: MutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteLocation), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('organization'),
      });
    },
  });
};
